export default __webpack_public_path__ + "static/media/_Api_auth.51f878fd.md";